/**************************
 * CURRENTLY USED IN ALL CONTACT FORMS EXCEPT CREATE ACCOUNT
 *************************/
// @react
import React from 'react'
// @typings
import { UseFormMethods } from 'react-hook-form'
// @components
import Grid from '@bit/atd.web.grid'
import InputPlacesAutocomplete from '@bit/atd.web.forms.input-places-autocomplete'
import strings from 'lib/constants/strings'

interface AddressComponent {
  long_name: string
  short_name: string
  types: string[]
}

type PropsType = {
  formMethods: UseFormMethods<any>
  index?: number
  name?: string
}

const GOOGLE_PLACES_KEY: string = process.env
  .REACT_APP_GOOGLE_PLACES_KEY as string

const getComponentName = (
  address_components: AddressComponent[] | undefined,
  componentName: string,
  type?: 'long_name' | 'short_name',
) => {
  if (!address_components) return ''
  const c = address_components.find((c) => c.types.includes(componentName))
  return c ? c[type ? type : 'long_name'] : ''
}

const AddressAutoComplete = ({ formMethods, index, name }: PropsType) => {
  return (
    <>
      <Grid xs={12} item>
        <InputPlacesAutocomplete
          name={name || `addressAutoComplete_${index}`}
          placeholder={strings.PROFILE.ACCESS.ADDRESS}
          label="Address Auto-Complete"
          apiKey={GOOGLE_PLACES_KEY}
          onChange={(value) => {
            if (typeof value === 'object') {
              const addrCountry: string = getComponentName(
                value.address_components,
                'country',
                'short_name',
              )
              const addrStNumber: string = getComponentName(
                value.address_components,
                'street_number',
              )
              const addrStName: string = getComponentName(
                value.address_components,
                'route',
              )
              const addrPostal: string = getComponentName(
                value.address_components,
                'postal_code',
              )
              const addrLocality: string = getComponentName(
                value.address_components,
                'locality',
              )
              const addrAdminArea1: string = getComponentName(
                value?.address_components,
                'administrative_area_level_1',
                'short_name',
              )

              // Set Country
              addrCountry !== '' &&
                formMethods.setValue(
                  typeof index === 'number'
                    ? `addresses[${index}].countryCode`
                    : `countryCode`,
                  addrCountry,
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  },
                )

              // Set Address (St # and St Name)
              if (addrStNumber !== '' || addrStName !== '') {
                formMethods.setValue(
                  typeof index === 'number'
                    ? `addresses[${index}].address1`
                    : `address1`,
                  `${
                    addrStNumber !== '' ? addrStNumber + ' ' : ''
                  } ${addrStName}`,
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  },
                )
              }

              // Set City
              addrLocality !== '' &&
                formMethods.setValue(
                  typeof index === 'number'
                    ? `addresses[${index}].city`
                    : `city`,
                  addrLocality,
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  },
                )

              // Set State, Province, Prefecture
              addrAdminArea1 !== '' &&
                formMethods.setValue(
                  typeof index === 'number'
                    ? `addresses[${index}].state`
                    : `state`,
                  addrAdminArea1,
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  },
                )

              // Set Zip, Post, Postal Codes
              addrPostal !== '' &&
                formMethods.setValue(
                  typeof index === 'number'
                    ? `addresses[${index}].postalCode`
                    : `postalCode`,
                  addrPostal,
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  },
                )
            }
          }}
        />
      </Grid>
    </>
  )
}

export default AddressAutoComplete
